import { Link } from "react-router-dom";
import { Button } from "rsuite";
import { AppRoutesUI } from '../../config/appRoutes';

export const AddSuperAdminButton = () => {
  return (
    <Link to={AppRoutesUI.SuperAdmin.SuperAdminCreate()}>
      <Button className="listPage-add-button" appearance="primary" size="md">
        Add New Super Admin
      </Button>
    </Link>
  );
};
